import React, { Component } from 'react'
import { PropTypes } from 'prop-types'

import { Page, Sidebar} from './ui'
import { routeStructBuilder } from '../common/genericHelper'
import './style/main.scss';

export class Layout extends Component {

  static propTypes = {
    children: PropTypes.node,
    routes: PropTypes.array
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor() {
    super()
    this.prism = window.Prism
    this.menuChanged = this.menuChanged.bind(this)
    if(this.prism) this.initiatePrism()
    this.state = { menuShow: false };
  }

  componentDidMount() {
    if(this.prism) this.initiatePrism()
  }
  onRouteChanged(){
    // close menu and scroll back up on mobile when we change route
    if(window.innerWidth <= 768){
      // on next tick, make sure menu is closed if open
      setTimeout(()=>{this.setState({ menuShow: false})},1)

    }
    window.scrollTo(0, 0);
  }
  componentDidUpdate(prevProps) {
    if(this.prism) this.initiatePrism()
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  initiatePrism() {
    const codeBlocks = Array.prototype.slice.call(document.getElementsByTagName('code'));
    codeBlocks.forEach(codeBlock=>{
      this.prism.highlightElement(codeBlock);
    });
  }

  menuChanged(evt, value) {
    this.setState({ menuShow: value !== undefined ? value : !this.state.menuShow })
  }

  render() {
    const { routes, children } = this.props;
    const pageRouteStruct = routeStructBuilder({routes, type:'pages'})

    const { pathname } = this.context.router.getCurrentLocation() || {}

    return (
      <Page>
        { React.Children.map(children, child => {
          return React.cloneElement(child, {
            curMenuState: this.state.menuShow,
            onMenuChange: this.menuChanged,
            routeStruct: pageRouteStruct
          })
        }) }
        <Sidebar
          isOpen={this.state.menuShow}
          currentPath={pathname}
          routeStruct={pageRouteStruct}
          curMenuState={this.state.menuShow}
          onMenuChange={this.menuChanged}
          className={pathname === '/' && 'landing'}
        />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./component/Layout.js